import { Logo } from '@/components/marca/Logo'

/** Pantalla neutra mientras Clerk y /api/sesion responden. */
export function Cargando() {
  return (
    <main
      className="flex min-h-dvh items-center justify-center"
      aria-busy="true"
      aria-label="Cargando"
    >
      <Logo variante="corto" className="h-8 animate-pulse opacity-60" />
    </main>
  )
}
